import { createStyles } from '@material-ui/core/styles';

export default createStyles({
     formContainer: {
    'height': 'calc(100vh - 58px)',
    'display': 'flex',
    'flexDirection': 'column',

    '& .textFieldWrapper': {
        '&:has(div > div > input[name="Price"])': {
      flexWrap: 'nowrap !important' as any,
    },
    }
  },
});
